import React from 'react';

export interface ProjectTab {
  /** Stable key used for the active comparison and passed back to onSelect. */
  key: string;
  /** Already-translated label shown on tablet/desktop. */
  label: string;
  /** Feather icon name without the `feather-` prefix, shown on mobile. */
  icon: string;
}

export interface ProjectTabsBarProps {
  tabs: ProjectTab[];
  activeKey: string;
  onSelect: (key: string) => void;
}

/**
 * Shared project-view tab bar: bordered tabs (`nav-tabs-custom-style`) that on
 * small screens collapse to icons and become a horizontally swipeable strip
 * with a hidden scrollbar (`nav-tabs-scroll`). The caller supplies the tab list
 * (already translated, already filtered for the role) — this component decides
 * nothing about visibility or permissions.
 */
export function ProjectTabsBar({ tabs, activeKey, onSelect }: ProjectTabsBarProps) {
  return (
    <div className="mb-4 nav-tabs-scroll">
      <ul className="nav nav-tabs nav-tabs-custom-style flex-nowrap" role="tablist" style={{ minWidth: 'max-content' }}>
        {tabs.map(tab => (
          <li key={tab.key} className="nav-item" role="presentation">
            <button
              className={`nav-link px-3 ${activeKey === tab.key ? 'active' : ''}`}
              onClick={() => onSelect(tab.key)}
            >
              <i className={`feather-${tab.icon} d-sm-none me-0`}></i>
              <span className="d-none d-sm-inline">{tab.label}</span>
            </button>
          </li>
        ))}
      </ul>
    </div>
  );
}
